import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getRankingComics } from '@/mocks/comics';

type RankFilter = 'rating' | 'views' | 'chapters';

export default function RankingSection() {
  const [filter, setFilter] = useState<RankFilter>('rating');
  const comics = getRankingComics();

  const filterLabels: { key: RankFilter; label: string }[] = [
    { key: 'rating', label: '评分榜' },
    { key: 'views', label: '人气榜' },
    { key: 'chapters', label: '连载榜' },
  ];

  const sortedComics = [...comics].sort((a, b) => {
    if (filter === 'rating') return b.rating - a.rating;
    if (filter === 'views') return b.views - a.views;
    return b.chapters - a.chapters;
  });

  return (
    <section className="py-14 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-1">排行榜</h2>
            <p className="text-sm text-foreground-500">看看大家都在追什么</p>
          </div>
          <div className="flex items-center gap-1 bg-background-50 rounded-full p-1 border border-background-200">
            {filterLabels.map(f => (
              <button
                key={f.key}
                onClick={() => setFilter(f.key)}
                className={`px-4 py-1.5 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${filter === f.key ? 'bg-primary-500 text-white font-medium' : 'text-foreground-600 hover:text-primary-500'}`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-5">
          {sortedComics.slice(0, 10).map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-0 left-0 w-8 h-8 flex items-center justify-center bg-primary-500 text-white text-sm font-bold rounded-br-lg">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">{comic.title}</h3>
              <p className="text-xs text-foreground-500 mt-1">
                {filter === 'rating' && `评分 ${comic.rating}`}
                {filter === 'views' && `${(comic.views / 10000).toFixed(0)}万阅读`}
                {filter === 'chapters' && `${comic.chapters}话`}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}